const MuiList = {
  root: {
    display: "flex",
    flexDirection: "column",
    gridGap: 8,
    marginTop: 10,
  },
};

export default MuiList;
